import React from 'react';
import { useTheme } from '@mui/material/styles';

const AheadIcon = ({ size = 40, style = {}, ...props }) => {
  const theme = useTheme();
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      {...props}
    >
      {/* Background circle with subtle gradient */}
      <defs>
        <linearGradient id="bgGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={theme.palette.primary.main} />
          <stop offset="100%" stopColor={theme.palette.primary.dark || theme.palette.primary.main} />
        </linearGradient>
      </defs>
      <circle
        cx="16"
        cy="16"
        r="15"
        fill="url(#bgGradient)"
        stroke={theme.palette.primary.dark || theme.palette.primary.main}
        strokeWidth="0.5"
      />
      
      {/* Two mountain peaks */}
      <path
        d="M8 24L12 16L16 20L20 12L24 24"
        stroke={theme.palette.background.paper}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      
      {/* Sun/star above the mountains */}
      <circle
        cx="16"
        cy="6"
        r="2"
        fill={theme.palette.background.paper}
        opacity="1"
      />
      <circle
        cx="16"
        cy="6"
        r="1"
        fill={theme.palette.primary.main}
        opacity="0.3"
      />
      
      {/* Subtle base line for stability */}
      <line
        x1="8"
        y1="26"
        x2="24"
        y2="26"
        stroke={theme.palette.background.paper}
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.6"
      />
    </svg>
  );
};

export default AheadIcon; 